import classNames from "classnames";
import { Tooltip } from "antd";

import { RightPanelMode } from "../../providers/DataPageRightPanelProvider";
import MetadataSummaryIcon from "assets/icons/MetadataSummaryIcon";
import LabelPropagationIcon from "assets/icons/LabelPropagationIcon";

import styles from "./style.module.scss";
import { FlywheelStatus } from "../../../vl-api/vlSchemas";

interface ViewToggleButtonsProps {
  currentView: RightPanelMode;
  onViewChange: (view: RightPanelMode) => void;
  flywheelStatus?: FlywheelStatus | undefined;
  showLabelPropagation?: boolean;
}

const FLYWHEEL_STATUS_TEXT: Partial<Record<FlywheelStatus, string>> = {
  INIT: "INITIALIZING",
  RUNNING: "RUNNING",
  RESUME_FLOW: "RUNNING",
  APPLY_MODEL_TO_DATASET: "RUNNING",
  PAUSED_FOR_REVIEW: "NEEDS REVIEW",
};

const FLYWHEEL_STATUS_TOOLTIP: Partial<Record<FlywheelStatus, string>> = {
  INIT: "Label Propagation is starting",
  RUNNING: "Label Propagation is running. The dataset is Read Only",
  RESUME_FLOW: "Label Propagation is running. The dataset is Read Only",
  APPLY_MODEL_TO_DATASET: "Applying labels to the whole dataset",
  PAUSED_FOR_REVIEW: "Paused until you review the new batch",
};

const ViewToggleButtons = ({
  currentView,
  onViewChange,
  showLabelPropagation,
  flywheelStatus,
}: ViewToggleButtonsProps) => {
  const summaryButtonClassNames = classNames(styles.toggleButton, {
    [styles.active]: currentView === "summary",
  });
  const labelsButtonClassNames = classNames(styles.toggleButton, {
    [styles.active]: currentView === "labels",
  });

  return (
    <div className={styles.viewToggleContainer}>
      <Tooltip title="Insights Panel" mouseEnterDelay={0.6}>
        <button
          className={summaryButtonClassNames}
          onClick={() => onViewChange("summary")}
          aria-label="Insights Panel"
        >
          <MetadataSummaryIcon />
        </button>
      </Tooltip>
      {showLabelPropagation && (
        <Tooltip
          title={
            (flywheelStatus && FLYWHEEL_STATUS_TOOLTIP[flywheelStatus]) ||
            "Label Propagation"
          }
          mouseEnterDelay={0.6}
        >
          <button
            className={labelsButtonClassNames}
            onClick={() => onViewChange("labels")}
            aria-label="Label Propagation"
          >
            <LabelPropagationIcon />
            {flywheelStatus &&
              !["FAILED", "ABORTED", "COMPLETED"].includes(flywheelStatus) && (
                <div
                  className={classNames(
                    styles.flywheelStatus,
                    styles[flywheelStatus],
                  )}
                >
                  {FLYWHEEL_STATUS_TEXT[flywheelStatus]}
                </div>
              )}
          </button>
        </Tooltip>
      )}
    </div>
  );
};

export default ViewToggleButtons;
